module.exports = __webpack_public_path__ + "static/media/mt-sos-logo.f482cec5.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/seals/MT/mt-sos-logo.png
// module id = 1661
// module chunks = 0